import { Configs } from './types';

export const appConfigs: Configs = {
  DEFAULT: {
    apiBaseUrl: 'https://mixbricks.art',
    appBaseUrl: 'http://localhost:3000',
  },
  DEV: {
    apiBaseUrl: 'https://mixbricks.art',
    appBaseUrl: 'http://localhost:3000',
  },
  PROD: {
    apiBaseUrl: 'https://mixbricks.art',
    appBaseUrl: 'https://mixbricks.art',
  },
};
